var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"money"},[(_vm.amount)?_c('p',{staticClass:"i-text"},[_vm._v(_vm._s(_vm.formatAmount))]):_c('p',[_vm._v(_vm._s(`${_vm.prefix} 00.00`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }